export const FORM_FIELDS = {
   SRC: 'imageUrl',
   WIDTH: 'imageWidth',
   HEIGHT: 'imageHeight',
   ALT_TEXT: 'imageAltText',
} as const;